import { Grid } from 'antd';

const { useBreakpoint } = Grid;

export default function useWidth() {
  const screens = useBreakpoint();

  if (screens.xl) return 'xl';
  if (screens.lg) return 'lg';
  if (screens.md) return 'md';
  if (screens.sm) return 'sm';
  return 'xs';
}
